import { BackupsApi } from 'src/orchd-client';

import { axiosInstance } from 'src/utils/axios';

export const backupsApi = BackupsApi({}, '/api', axiosInstance);
